import { useState, useEffect } from 'react';
import { Container, Table, Button, Form, Modal, Alert, Row, Col } from 'react-bootstrap';
import { db } from '../firebase';
import { collection, doc, getDocs, addDoc, updateDoc, deleteDoc } from 'firebase/firestore';

const JUEGOS = ['Pokémon TCG', 'Magic: The Gathering', 'Dragon Ball Super', 'Digimon TCG', 'One Piece', 'Ultrapro'];
const TIPOS = ['ETB', 'Booster Box', 'Bundle', 'Single', 'Sleeves', 'Deck Box', 'Accesorios', 'Playmat'];

const ProductCatalog = () => {
  const [products, setProducts] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const fetchProducts = async () => {
      const querySnapshot = await getDocs(collection(db, 'products'));
      setProducts(querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    };
    fetchProducts();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const productData = {
        ...formData,
        precioDistribuidor: Number(formData.precioDistribuidor),
        precioPublico: Number(formData.precioPublico),
        fechaCreacion: new Date()
      };

      if (formData.id) {
        await updateDoc(doc(db, 'products', formData.id), productData);
        setSuccess('Producto actualizado');
      } else {
        await addDoc(collection(db, 'products'), productData);
        setSuccess('Producto creado');
      }
      
      setShowModal(false);
      setFormData({});
    } catch (err) {
      setError(err.message);
    }
    setTimeout(() => { setError(''); setSuccess(''); }, 3000);
  };

  return (
    <Container className="my-5">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2>Catalogo de Productos</h2>
        <Button variant="success" onClick={() => setShowModal(true)}>+ Crear Producto</Button>
      </div>

      {error && <Alert variant="danger">{error}</Alert>}
      {success && <Alert variant="success">{success}</Alert>}

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Juego</th>
            <th>Tipo</th>
            <th>P. Distribuidor</th>
            <th>P. Público</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {products.map(product => (
            <tr key={product.id}>
              <td>{product.nombre}</td>
              <td>{product.juego}</td>
              <td>{product.tipo}</td>
              <td>₡{product.precioDistribuidor?.toLocaleString()}</td>
              <td>₡{product.precioPublico?.toLocaleString()}</td>
              <td>
                <Button size="sm" onClick={() => { setFormData(product); setShowModal(true); }}>
                  Editar
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showModal} onHide={() => { setShowModal(false); setFormData({}); }}>
        <Modal.Header closeButton>
          <Modal.Title>{formData.id ? 'Editar' : 'Nuevo'} Producto</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Nombre del Producto *</Form.Label>
              <Form.Control 
                value={formData.nombre || ''}
                onChange={(e) => setFormData(prev => ({ ...prev, nombre: e.target.value }))}
                required
              />
            </Form.Group>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Juego *</Form.Label>
                  <Form.Select
                    value={formData.juego || ''}
                    onChange={(e) => setFormData(prev => ({ ...prev, juego: e.target.value }))}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    {JUEGOS.map(juego => <option key={juego} value={juego}>{juego}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tipo *</Form.Label>
                  <Form.Select
                    value={formData.tipo || ''}
                    onChange={(e) => setFormData(prev => ({ ...prev, tipo: e.target.value }))}
                    required
                  >
                    <option value="">Seleccionar...</option>
                    {TIPOS.map(tipo => <option key={tipo} value={tipo}>{tipo}</option>)}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Precio Distribuidor *</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.precioDistribuidor || ''}
                    onChange={(e) => setFormData(prev => ({ ...prev, precioDistribuidor: e.target.value }))}
                    min="0"
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Precio Público *</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.precioPublico || ''}
                    onChange={(e) => setFormData(prev => ({ ...prev, precioPublico: e.target.value }))}
                    min="0"
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={() => setShowModal(false)}>Cancelar</Button>
              <Button variant="primary" type="submit">Guardar</Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
};

export default ProductCatalog;